var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ouer-uploader",
      class: { "is-error": _vm.hasError },
      style: { width: _vm.size, height: _vm.size },
    },
    [
      _vm.imageUrl
        ? [
            _c("el-image", {
              staticClass: "upload-image",
              attrs: {
                src: _vm.imageUrl,
                "preview-src-list": [_vm.imageUrl],
                fit: "cover",
              },
            }),
            !_vm.disabled
              ? _c(
                  "div",
                  {
                    staticClass: "clear-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onClear.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-circle-close" })]
                )
              : _vm._e(),
          ]
        : _c(
            "el-upload",
            {
              staticClass: "avatar-uploader",
              attrs: {
                action: "#",
                accept: "image/*",
                "show-file-list": false,
                disabled: _vm.disabled,
                "on-change": _vm.onSelect,
                "http-request": _vm.onRequest,
              },
            },
            [_c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })]
          ),
      _vm.hasError
        ? _c("div", { staticClass: "upload-error" }, [
            _vm._v(_vm._s(_vm.errMessage)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }